<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!-- <br /> -->
    <!-- <v-card class="box" v-if="(child_notice = null)">
      <center>
        <h3 style="color: green">Currently there are no notices added.</h3>
      </center>
    </v-card> -->
    <v-row dense justify="center">
      <v-col cols="12" sm="5" md="3">
        <span v-for="header in headers" :key="header.text">
          <span v-if="filters.hasOwnProperty(header.value)">
            <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined color="#0F2027"
              :label="header.text" multiple clearable :items="columnValueList(header.value)"
              v-model="filters[header.value]"></v-autocomplete>
          </span>
        </span>
      </v-col>
      <v-col cols="12" sm="1" md="1"></v-col>
      <v-col cols="12" sm="5" md="4">
        <v-text-field v-model="search" append-icon="search" label="Search" single-line
          placeholder="Search by Title / Decription / Date" clearable></v-text-field>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" sm="6" md="6" v-for="notice in searchByTitleOrDescription" :key="notice.id">
        <v-card dense class="box" :elevation="2" height="100%" @current-items="getFiltered">
          <v-chip class="ma-2" :color="!notice.visited ? 'warning' : 'info'">
            {{ notice.issue_date }}
          </v-chip>
          <v-card-title class="title font-weight-regular">
            {{ notice.title }}
          </v-card-title>
          <v-card-title class="title font-weight-regular" v-if="notice.webinar_link != null">
            <a class="p-2" :href="notice.webinar_link" target="blank">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-if="notice.webinar_link" v-bind="attrs" v-on="on">
                    <v-icon color="black">mdi-eye</v-icon></v-btn>
                </template>
                <span> Visit Link !!! </span>
              </v-tooltip>
            </a>
          </v-card-title>
          <v-card-title class="body-2 font-weight-regular">
            <v-btn class="ma-2" small outlined color="indigo" v-if="!notice.visited" @click="viewMore(notice)">View
              More</v-btn>
            <span v-if="notice.visited">Description:{{ notice.description }}
            </span>
          </v-card-title>

          <v-card-actions>
            <v-card-subtitle v-if="notice.attachment" class="font-regular">
              Downloadable Attachment
              <span v-for="(item, i) in notice.attachment_links" :key="i">
                <a class="p-2" :href="basepath + item.path + item.name" target="blank">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-if="notice.attachment != null" v-bind="attrs" v-on="on">
                        <v-icon color="black">mdi-download</v-icon></v-btn>
                    </template>
                    <span> View Attachment File!!! </span>
                  </v-tooltip>
                </a>
              </span>
            </v-card-subtitle>

            <v-spacer> </v-spacer><v-card-subtitle> from @{{ notice.from }}</v-card-subtitle>
          </v-card-actions>
        </v-card>
      </v-col>
      <!-- <br /> -->
    </v-row>
    <!-- {{ child_info }} -->
  </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    child_info: null,
    children: [],
    selected_children: "",
    child_notice: null,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    loader: true,
    search: "",
    s3url: "",
    basepath: "",
    headers: [{ text: "Academic Year", value: "academicyear" }],
    filters: {
      academicyear: [],
    },
  }),

  methods: {
    columnValueList(val) {
      return this.child_notice.notices.map((d) => d[val]);
    },
    getFiltered(e) {
      this.filterArr = e;
    },
    viewMore(notice) {
      const formData = {
        id: notice.comm_parent_id,
        type: "Notice",
      };
      axios
        .post("/parent/noticeOrAlbumViewedByParent", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            if (res.data.status == "SUCCESS") {
              // this.child_info = res.data.child_info;
              // this.childrenList();
              notice.visited = true;
            } else {
              alert(res.data.status_reason);
            }
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.loader = false;
          //alert("done")
        });
    },
    downloadNoticeAttachment(dlinkpath) {
      //let s3url = "https://eduplusschool.s3.ap-south-1.amazonaws.com/";

      //console.log("dlinkpath>>"+dlinkpath)
      for (let j = 0; j < dlinkpath.length; j++) {
        var link = document.createElement("a");
        let path = dlinkpath[j].path;
        link.download = dlinkpath[j].name; // 16yqok7xkop.xls
        //console.log("url>>"+s3url+path+link.download)
        link.href = this.s3url + path + link.download;
        link.target = "_blank";
        link.click();
      }
    },
    childrenList() {
      //console.log(" children Len>>"+this.child_info.length)
      for (let i = 0; i < this.child_info.length; i++) {
        //console.log(" children>>"+this.child_info[i].grno)
        this.children.push(
          this.child_info[i].grno + ":" + this.child_info[i].name
        );
        this.selected_children =
          this.child_info[i].grno + ":" + this.child_info[i].name;
        this.displayNotice();
      }
      //console.log(" children>>"+this.children)
    },
    displayNotice() {
      //alert('11'+this.selected_children)
      let grno = this.selected_children;
      let res = grno.split(":");
      // return res[1];
      for (let i = 0; i < this.child_info.length; i++) {
        if (res[0] == this.child_info[i].grno)
          this.child_notice = this.child_info[i];
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.basepath = localStorage.getItem("awspath");
    this.s3url = localStorage.getItem("awspath");
    const formData = {
      type: "Notice",
    };
    axios
      .post("/parent/getNoticeHWAlbum", formData)
      .then((res) => {
        if (res.data.msg == "200") {
          if ((res.data.status = "SUCCESS")) {
            this.child_info = res.data.child_info;
            this.childrenList();
            if (this.child_notice.notices.length == 0) {
              this.showSnackbar("#b71c1c", "No Notices Available...");
              return;
            }
          } else {
            alert(res.data.status_reason);
          }
        }
      })
      .catch((error) => {
        window.console.log(error);
      })
      .finally(() => {
        //close loader
        this.loader = false;
        //alert("done")
      });
  },
  computed: {
    searchByTitleOrDescription() {
      if (this.child_notice) {
        return this.child_notice.notices.filter((tbdata) => {
          return Object.keys(this.filters).every((f) => {
            return (
              (this.filters[f].length < 1 ||
                this.filters[f].includes(tbdata[f])) &&
              (tbdata.title.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0 ||
                tbdata.description
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0 ||
                tbdata.issue_date
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
            );
          });

          // return (
          //   tbdata.title.toLowerCase().indexOf(this.search.toLowerCase()) >=
          //     0 ||
          //   tbdata.description
          //     .toLowerCase()
          //     .indexOf(this.search.toLowerCase()) >= 0 ||
          //   tbdata.issue_date
          //     .toLowerCase()
          //     .indexOf(this.search.toLowerCase()) >= 0
          // );
        });
      }

      // return this.child_notice.notices.filter((d) => {
      //   if (Object.keys(this.filters)) {
      //     return Object.keys(this.filters).every((f) => {
      //       return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
      //     });
      //   }

      // });
    },
  }, // end of computed()
};
</script>
